import React from 'react';
import { Form } from 'antd';

interface EditableRowProps {
  index: number;
}

const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
  return (
    <Form component={false}>
        <tr {...props} />
    </Form>
  );
};

export default EditableRow;
